/**
 * Códigos de erro do cadastro de empresa (CompanyService).
 */
export const COMPANY_ERRORS = {
  /** 404 — id de empresa que não existe (rotas de show/update/delete/schedules/owner). */
  NOT_FOUND: "ERR_NO_COMPANY_FOUND",
  /** 409 — `name` é unique no banco; edição/criação com nome já usado por outra empresa. */
  DUPLICATE_NAME: "ERR_COMPANY_DUPLICATE_NAME"
} as const;

export type CompanyErrorCode = (typeof COMPANY_ERRORS)[keyof typeof COMPANY_ERRORS];
